export default __webpack_public_path__ + "static/media/evolve-black.5f1e325f.svg";